import { FC } from "react"
import { UserbotPage } from "./userbotPage"
import { MembershipsTable } from "../components"

export const MembershipsPage: FC = () => (
  <UserbotPage title="Кэш членства">
    <MembershipsTable />
  </UserbotPage>
)
